import { render, staticRenderFns } from "./editList.vue?vue&type=template&id=2a4fcf40&scoped=true&"
import script from "./editList.vue?vue&type=script&lang=js&"
export * from "./editList.vue?vue&type=script&lang=js&"
import style0 from "./editList.vue?vue&type=style&index=0&id=2a4fcf40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4fcf40",
  null
  
)

export default component.exports